import { render } from "./StudyView.vue?vue&type=template&id=0536ae9a&scoped=true"
import script from "./StudyView.vue?vue&type=script&lang=js"
export * from "./StudyView.vue?vue&type=script&lang=js"

import "./StudyView.vue?vue&type=style&index=0&id=0536ae9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_webpack@5.99.8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0536ae9a"]])

export default __exports__